import cornerstoneTools from "cornerstone-tools";
import Util from "../api/Util";
import { TOOL_IDS } from "../consts/tools.consts";
import { ExtendedAnnotationTool } from "../api/ExtendedAnnotationTool";
import { ToolData } from "../tools.types";
import { renderSpinalLabels } from "./spinalLabel.functions";

const LUMBAR_CONFIGURATION = {
  markers: ["L1", "L2", "L3", "L4", "L5"],
  current: "L1",
  ascending: true,
  loop: true,
};
const LumbarTool = cornerstoneTools.TextMarkerTool;

export default class LumbarLabel extends ExtendedAnnotationTool {
  hasIncomplete: boolean;
  counter: number;
  constructor() {
    super(TOOL_IDS.LUMBAR_LABEL);
    this.hasIncomplete = false;
    this.counter = -1;
  }

  activeCallback(element) {
    cornerstoneTools.addTool(LumbarTool, { LUMBAR_CONFIGURATION });
  }

  preMouseDownCallback(event) {
    if (this.counter < LUMBAR_CONFIGURATION.markers.length - 1) {
      this.counter += 1;
    } else {
      this.counter = 0;
    }
  }

  createNewMeasurement(event) {
    const goodEventData =
      event && event.currentPoints && event.currentPoints.image;
    if (!goodEventData) {
      return;
    }

    const { x, y } = event.currentPoints.image;

    return {
      visible: true,
      active: true,
      color: "greenyellow",
      value: LUMBAR_CONFIGURATION.markers[this.counter],
      invalidated: true,
      handles: {
        start: {
          x,
          y,
          highlight: true,
          active: false,
        },
        end: {
          x,
          y,
          highlight: true,
          active: false,
        },
        textBox: {
          active: false,
          hasMoved: false,
          movesIndependently: false,
          drawnIndependently: true,
          allowedOutsideImage: true,
          hasBoundingBox: true,
        },
      },
    };
  }

  pointNearTool(element, data, coords) {
    const validParameters =
      data && data.handles && data.handles.start && data.handles.end;

    if (!validParameters) {
      // //console.log(
      //     `invalid parameters supplied to tool ${this.name}'s pointNearTool`
      // );
      return false;
    }

    if (data.visible === false) {
      return false;
    }

    if (this.hasIncomplete) {
      return false;
    }

    const line =
      Util.lineSegDistance(
        element,
        data.handles.start,
        data.handles.end,
        coords
      ) < 10;

    if (line) {
      data.handles.start.movesIndependently = false;
      data.handles.end.movesIndependently = false;
    }
    return line;
  }

  distanceFromPoint(event) {}

  drawToolData(
    element: HTMLElement,
    context: CanvasRenderingContext2D,
    toolData: ToolData
  ) {
    renderSpinalLabels(LUMBAR_CONFIGURATION, toolData, context, element);
  }

  _changeText(evt) {
    const eventData = evt.detail;
    const { element, currentPoints } = eventData;
    let data;

    function doneChangingTextCallback(data, updatedText, deleteTool) {
      if (deleteTool === true) {
        cornerstoneTools.removeToolState(element, this.name, data);
      } else {
        data.text = updatedText;
      }

      data.active = false;
      cornerstoneTools.updateImage(element);
    }

    const config = LUMBAR_CONFIGURATION;
    const coords = currentPoints.canvas;
    const toolData = cornerstoneTools.getToolState(element, this.toolId);

    // Now check to see if there is a handle we can move
    if (!toolData) {
      return;
    }

    for (let i = 0; i < toolData.data.length; i++) {
      data = toolData.data[i];
      if (this.pointNearTool(element, data, coords)) {
        data.active = true;
        cornerstoneTools.updateImage(element);

        // Allow relabelling via a callback
        // @ts-ignore
        config.changeTextCallback(data, eventData, doneChangingTextCallback);

        evt.stopImmediatePropagation();
        evt.preventDefault();
        evt.stopPropagation();

        return;
      }
    }
  }
}
